import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import * as Ps from 'perfect-scrollbar';
import 'perfect-scrollbar/dist/css/perfect-scrollbar.min.css';
import HeaderLinks from 'components/Header/HeaderLinks.jsx';
// import logo_integrar from '../../assets/img/logo_sem_texto.png'
import partnerRoutes from 'routes/partner.jsx';

export default class PartnerSidebar extends Component {
    constructor(props) {
        super(props);
        this.state = { width: window.innerWidth }
    }

    activeRoute(routeName) {
        return this.props.location.pathname.indexOf(routeName) > -1 ? 'active' : '';
    }

    updateDimensions() {
        this.setState({ width: window.innerWidth });
    }
    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            Ps.initialize(this.refs.sidebarWrapper, { wheelSpeed: 2, suppressScrollX: true });
        }
    }
    componentDidUpdate() {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            setTimeout(() => { Ps.update(this.refs.sidebarWrapper) }, 350);
        }
    }

    isMac() {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
    render() {
        return (

            <div className="sidebar">
                <div className="logo">
                ENELE
                    {/* <img src={logo_integrar} className="logo_image" alt="logo_integrar" /> */}
                </div>
                <div className="sidebar-wrapper" ref="sidebarWrapper">
                    <ul className="nav">
                        {this.state.width <= 992 ? (<HeaderLinks />) : null}
                        {
                            partnerRoutes.map((prop, key) => {
                                var st = {};
                                st[prop["state"]] = !this.state[prop.state];
                                if (prop.invisibleInSidebar) { return null }
                                else {
                                    if (prop.redirect) { return null }
                                    else {
                                        return (
                                            <li className={this.activeRoute(prop.path)} key={key}>
                                                <NavLink to={prop.path} className="nav-link" activeClassName="active">
                                                    <i className={prop.icon}></i>
                                                    <p>{prop.name}</p>
                                                </NavLink>
                                            </li>
                                        );
                                    }
                                }
                            })
                        }
                    </ul>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/PartnerSidebar.jsx